import { AssessmentDataCategory } from './../assessment-data-category';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../shared-components/angular-material/mat-animations';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AddAssessmentScoresComponent } from './add-assessment-scores/add-assessment-scores.component';

@Component({
    selector: 'assessment-data-category-table',
    templateUrl: './assessment-data-category-table.component.html',
    styleUrls: ['./assessment-data-category-table.component.css'],
    animations: [detailExpand],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssessmentDataCategoryTableComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

    // Properties
    private _sort: MatSort;
    @Input() data: TylerMatTableDataSource;
    @Input() tabIndex: number;
    @Output() detailOpened = new EventEmitter<AssessmentDataCategory>();
    @Input() showChildFilters = true;
    @Input() triggerChanges: EventEmitter<any>;
    triggerChangeSubscription: Subscription;
    selectedRow: AssessmentDataCategory;
    headerColumns: string[] = ['More', 'fullTitle', 'action'];

    // Class Functions
    constructor(
        private dialog: MatDialog,
        private changeDetector: ChangeDetectorRef,
        private router: Router
    ) {
        if (this.router.url.toLowerCase().indexOf('registrationenrollment') == -1)
            this.headerColumns = this.headerColumns.filter(c => c != 'action');
    }

    get sort(): MatSort {
        return this._sort;
    }

    @ViewChild(MatSort, { static: true }) set sort(value: MatSort) {
        this._sort = value;
        if (this.data) {
            this.data.sort = this._sort;
        }
    }

    // Event Functions
    ngOnInit() {
        // POST: subscribes to manual changes
        if (this.triggerChanges) {
            this.triggerChangeSubscription = this.triggerChanges.subscribe(() => {
                this.changeDetector.markForCheck();
            });
        }
    }

    ngAfterViewInit() {
        // POST: sets the sort of the data
        if (this.data && this.sort) {
            this.data.sort = this.sort;
        }
    }

    ngOnChanges() {
        // POST: sets the sort of the data
        if (this.data && this.sort) {
            this.data.sort = this.sort;
        }
    }

    ngOnDestroy() {
        // POST: unsubscribes from manual changes
        if (this.triggerChangeSubscription) {
            this.triggerChangeSubscription.unsubscribe();
        }
    }

    rowClick(row: AssessmentDataCategory) {
        // PRE: a row is clicked
        // POST: toggles that row and detects changes
        this.data.toggleExpanded(row);
        this.detailOpened.emit(row);
        this.selectedRow = row;
        setTimeout(() => {
            this.triggerChanges.emit();
        }, 0);
    }

    addScores(event) {
        event.stopPropagation();
        this.dialog.open(AddAssessmentScoresComponent, { panelClass: 'tyl-mat-dialog', disableClose: true });
    }

}